<div
  class="layout-breadcrumb-container flex justify-between items-center"
  aria-label="breadcrumbs"
  role="navigation"
>
  <p-breadcrumb
    [model]="items.length ? items : undefined"
    [home]="home"
    styleClass="layout-breadcrumb"
    [homeAriaLabel]="'ariaLabels.HOME_PAGE' | translate"
  ></p-breadcrumb>
</div>
